import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AmountStatus, EventItem, Lookups, Race, RaceRegistration} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {AbstractComponent} from "../../abstract.component";

@Component({
  selector: 'app-order-grid-item',
  templateUrl: './order-grid-item.component.html',
  styleUrl: './order-grid-item.component.scss',
  standalone: false
})
export class OrderGridItemComponent extends AbstractComponent implements OnInit {

  @Input() registration: RaceRegistration | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Output() onOpenOrderCallback: EventEmitter<void> = new EventEmitter<void>();

  race: Race | undefined;
  eventItem: EventItem | undefined;
  amountStatus: AmountStatus = AmountStatus.NOT_PAID;

  constructor(public translocoService: TranslocoService) {
    super();
  }

  ngOnInit(): void {
    this.race = this.registration?.race;
    this.eventItem = this.registration?.events;
    this.amountStatus = RaceRegistration.getAmountStatus(this.registration);
  }

  onOpenOrder(): void {
    this.onOpenOrderCallback.emit();
  }

  protected readonly AmountStatus = AmountStatus;
}
